import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent, TypographyComponent } from 'components';

@Component({
	standalone: true,
	selector: 'app-sl-kpi-card',
	imports: [NgIf, IconComponent, TypographyComponent, MatTooltip],
	templateUrl: './sl-kpi-card.component.html',
	styleUrls: ['./sl-kpi-card.component.scss']
})
export class SlKpiCardComponent {
	@Input() label: string = '';
	@Input() value: string | number = '';
	@Input() change: number | null = null;
	@Input() good: boolean | null = null;
	@Input() showInfo = false;
	/**
	 * What the info glyph explains — as a tooltip and as the glyph's accessible
	 * name. Without it `showInfo` draws a hint that answers nothing, so every
	 * call site that opts into the glyph should pass this too.
	 */
	@Input() infoTooltip: string | null = null;
	@Input() description: string | null = null;

	get displayValue(): string {
		if (typeof this.value === 'number') {
			return SlKpiCardComponent.formatNumber(this.value);
		}
		return this.value;
	}

	get changeLabel(): string {
		if (this.change === null) return '';
		const arrow = this.change >= 0 ? '↑' : '↓';
		return `${arrow} ${Math.abs(this.change)}%`;
	}

	private static formatNumber(n: number): string {
		if (Math.abs(n) >= 1_000_000) {
			return (
				(n / 1_000_000).toLocaleString('en-US', {
					maximumFractionDigits: 1
				}) + 'M'
			);
		}
		return n.toLocaleString('en-US');
	}
}
